import { createFileRoute, Link } from "@tanstack/react-router";
import { concepts } from "@/components/koncepcje";

const title = "Koncepcje wizualne | Sylwia Sitkowska";
const description =
  "Trzy kierunki wizualne strony Sylwii Sitkowskiej: Redakcja, Manifest i Dokument, z podglądem desktop i mobile.";

export const Route = createFileRoute("/koncepcje/")({
  head: () => ({
    meta: [
      { title },
      { name: "description", content: description },
      { property: "og:title", content: title },
      { property: "og:description", content: description },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: Koncepcje,
});

function Koncepcje() {
  return (
    <main className="min-h-screen bg-mist">
      <div className="container-page section-pad">
        <p className="eyebrow">Wybór kierunku</p>
        <h1 className="mt-5 text-3xl md:text-4xl">Trzy koncepcje wizualne</h1>
        <p className="mt-4 max-w-2xl text-sm leading-relaxed text-coral-text">
          Każdą koncepcję możesz otworzyć na pełnym ekranie i przełączać widok desktop / mobile.
        </p>

        <div className="mt-12 space-y-16">
          {concepts.map((c) => (
            <article key={c.id} className="border border-steel bg-surface">
              <div className="flex flex-wrap items-center justify-between gap-4 border-b border-steel px-6 py-5">
                <div>
                  <h2 className="text-xl">{c.name}</h2>
                  <p className="mt-1 text-sm text-coral-text">{c.tagline}</p>
                </div>
                <div className="flex gap-3">
                  <Link
                    to="/koncepcje/$id"
                    params={{ id: c.id }}
                    search={{ device: "desktop" as const }}
                    className="btn-base btn-primary"
                  >
                    Pełny ekran, desktop
                  </Link>
                  <Link
                    to="/koncepcje/$id"
                    params={{ id: c.id }}
                    search={{ device: "mobile" as const }}
                    className="btn-base btn-outline"
                  >
                    Pełny ekran, mobile
                  </Link>
                </div>
              </div>

              <div className="max-h-[26rem] overflow-hidden border-b border-steel">
                <div className="pointer-events-none origin-top scale-[0.62]" style={{ width: "161%" }}>
                  <c.Preview device="desktop" />
                </div>
              </div>

              <dl className="grid gap-6 px-6 py-6 text-sm md:grid-cols-3">
                <div>
                  <dt className="eyebrow">Co jest nowoczesne</dt>
                  <dd className="mt-2 text-ink/80">{c.modern}</dd>
                </div>
                <div>
                  <dt className="eyebrow">Potrzebne materiały</dt>
                  <dd className="mt-2 text-ink/80">{c.materials}</dd>
                </div>
                <div>
                  <dt className="eyebrow">Ryzyko</dt>
                  <dd className="mt-2 text-ink/80">{c.risk}</dd>
                </div>
              </dl>
            </article>
          ))}
        </div>
      </div>
    </main>
  );
}
